module.exports = __webpack_public_path__ + "static/media/email.2b6b43b5.svg";